import { useAllFlags } from '@/hooks/useAllFlags';
import { CheckCircle2 } from 'lucide-react';
import styles from './SenderDetailsSelector.module.css';

interface SenderDetailsSelectorProps {
  value: boolean;
  onChange: (value: boolean) => void;
}

export function SenderDetailsSelector({ value, onChange }: SenderDetailsSelectorProps) {
  const { ld, partnerFlags } = useAllFlags();

  if (
    ld['enable-point-of-contact-sender'] !== true ||
    partnerFlags?.engage?.enablePointOfContactSender !== true
  ) {
    return null;
  }

  return (
    <fieldset className={styles.fieldset}>
      <legend>Sender Details</legend>
      <p className={styles.subtitle}>This selection applies to every email in this automation.</p>
      <div className={styles.options}>
        <button type="button" aria-pressed={!value} onClick={() => onChange(false)}>
          {!value && <CheckCircle2 className={styles.checkIcon} />}
          <span>Business default</span>
          <p>Send using this business's configured sender name and reply-to address.</p>
        </button>
        <button type="button" aria-pressed={value} onClick={() => onChange(true)}>
          {value && <CheckCircle2 className={styles.checkIcon} />}
          <span>Customer's point of contact</span>
          <p>Send using the name and email of the contact person assigned to each customer.</p>
        </button>
      </div>
    </fieldset>
  );
}
